import type {PhotoRequirement} from './types';

/**
 * Collect a group sentinel plus every transitive member id (direct children and
 * anything nested inside member sub-groups), starting from `rootId`. Returns the
 * set of ids including `rootId` itself.
 *
 * Shared by header serialization (`serializeHeaderGroup`), preset application,
 * and header-scope resolution, which all need the same transitive-descendant walk.
 */
export function collectGroupTree(requirements: PhotoRequirement[], rootId: string): Set<string> {
  const ids = new Set<string>([rootId]);
  let grew = true;
  while (grew) {
    grew = false;
    for (const r of requirements) {
      if (r.group_id !== undefined && ids.has(r.group_id) && !ids.has(r.id)) {
        ids.add(r.id);
        grew = true;
      }
    }
  }
  return ids;
}
